import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Title, SimpleForm, FileInput, FileField, BooleanInput, Toolbar, SaveButton, useDataProvider } from 'react-admin';
import ImportIcon from '@material-ui/icons/Publish';

const ImportToolBar = (props: any) => {
const dataProvider = useDataProvider();

const submitAction = (params: any) => {
    dataProvider.import('favorites/import', params);
}


 return <Toolbar {...props} >
   <SaveButton label="Import" icon={<ImportIcon />} redirect="/"
  onSave={submitAction} />
 </Toolbar>
};

const ImportFavorites = () => (
    <Card>
        <Title title="Import Favorites" />
        <CardContent>
            <SimpleForm toolbar={<ImportToolBar />}>
                <FileInput source="files" label="Favorites" accept=".csv" multiple={false}>
                    <FileField source="src" title="title" />
                </FileInput>
                <BooleanInput source="skipFirstLine" label="Skip first line" initialValue={true} />
                {/*<BooleanInput source="overwrite" label="Overwrite existing favorites" initialValue={true} />*/}
            </SimpleForm>
        </CardContent>
    </Card>
);

export default ImportFavorites;